import React, {PureComponent} from 'react';
import {noop} from '@ultradent/utilities/Functions';
import cx from 'classnames';
import invoke from 'lodash.invoke';
import Button from '../../Button';

// Deals with paginating each result set individually
class SearchResultsPagination extends PureComponent {
    static defaultProps = {
        showPagination: false,
        pageIndex: 0,
        groupIndex: 0,
        resultPerPage: Infinity,
        results: [],
        onPageIndexChange: noop
    };

    constructor ( props ) {
        super( props );
        this.loadMore = this.loadMore.bind( this );

        this.state = {
            pageIndex: props.pageIndex || 0
        }
    }

    loadMore () {
        const {results, resultsPerPage, onPageIndexChange, groupIndex} = this.props;
        const maxPageIndex = Math.ceil( results.length / resultsPerPage );
        const pageIndex = Math.min(
            Math.max( 0, this.state.pageIndex + 1 ),
            maxPageIndex - 1
        );
        onPageIndexChange( pageIndex, groupIndex );
        this.setState( {pageIndex} );
    }

    getPagedResults ( results, countPerPage, pageIndex ) {
        return results.slice( 0, countPerPage * (pageIndex + 1) );
    }

    showPagination ( currentResultCount ) {
        const {results, showPagination} = this.props;
        return showPagination && (currentResultCount < results.length);
    }

    render () {
        const {groupIndex, results, resultsPerPage, className} = this.props;
        const pagedResults = this.getPagedResults( results, resultsPerPage, this.state.pageIndex );

        // send result updates back to Container in order to manage focus and item selections
        // from current result set properly
        invoke( this.props, 'onResultsChange',
            groupIndex,
            {
                results: pagedResults,
                resultCount: pagedResults.length
            }
        );

        if ( !pagedResults.length ) {
            return null;
        }

        return (
            <div className={cx( className )}>
                {this.props.children( {pagedResults} )}
                {this.showPagination( pagedResults.length ) &&
                    <div className="flex flex-col items-center mt-8" data-testid="pagination-summary">
                    <p className="text-xs uppercase txt-c2 tracking-wide">
                        Showing {pagedResults.length} of {results.length}
                    </p>
                    <Button className="mt-2" secondary onClick={this.loadMore}>{
                        (pagedResults.length + resultsPerPage < results.length)
                            ? `Next ${resultsPerPage} results`
                            : 'Remaining results'}
                    </Button>
                </div>
                }
            </div>
        );
    }
}

export default SearchResultsPagination;
